import { cn } from '@finn/ui-utils';
import { useCallback } from 'react';

import { GenericVehicleDetails } from '../../../core';
import { PDPTracking, useTrackingData } from '../../tracking/PDPTracking';

type VehicleColorsProps = {
  product: GenericVehicleDetails;
  onColorChange: (configId: number) => void;
  isMobile?: boolean;
};

export const VehicleColors = ({
  product,
  onColorChange,
  isMobile = false,
}: VehicleColorsProps) => {
  const trackingData = useTrackingData();
  const colors = (product.color_list ?? []).filter(
    (color) => color.availability || color.car_id === product.id
  );

  const trackColorChange = useCallback(
    (color: string) => {
      PDPTracking.colorClicked({ ...trackingData, color });
    },
    [trackingData]
  );

  return (
    <div
      className={cn(
        'flex flex-wrap items-center justify-start md:max-w-20',
        isMobile ? 'gap-2' : 'gap-1.5'
      )}
    >
      {colors.map((color) => (
        <div
          title={color.color_specific}
          key={color.car_id}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            trackColorChange(color.color_specific);
            onColorChange(color.uid);
          }}
          className={cn(
            'group flex cursor-pointer items-center justify-center rounded-full border border-solid outline-none',
            {
              'border-black': color.car_id === product.id,
              'border-white hover:border-iron focus:border-iron':
                color.car_id !== product.id,
            }
          )}
        >
          <div
            className={cn(
              'rounded-full border-2 border-solid border-pearl',
              isMobile && 'size-6',
              !isMobile && 'size-5'
            )}
            style={{ backgroundColor: color.color_hex }}
          />
        </div>
      ))}
    </div>
  );
};
